import "core-js/modules/es.array.includes.js";
import { compatibleLang } from './utils';
/**
 * 判断是否为中文
 * @param {String} lang
 */
var i18nIsZh = function i18nIsZh(lang) {
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  // lang兼容处理
  lang = compatibleLang(lang);
  return lang.indexOf('zh-') === 0 || lang.indexOf('zh_') === 0;
};

/**
 * 是否是相对中文较长的语言
 * @param {String} lang
 */
var i18nIsLongLang = function i18nIsLongLang(lang) {
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  // lang兼容处理
  lang = compatibleLang(lang);

  // 语言相对中文较长的语言
  var LANGUAGE_LONG = ['en', 'ar', 'de', 'ru', 'fr', 'tl', 'pt', 'ja', 'th', 'tr', 'es', 'id', 'vi'];
  return LANGUAGE_LONG.includes(lang);
};

/**
 * 切换全角半角
 * @param {String} str
 * @param {String} type
 */
var toggleHalfFullWidth = function toggleHalfFullWidth(punctuation, type) {
  var c = punctuation.charCodeAt(0);
  if (c >= 65281 && c <= 65374 && type === 'toHalf') {
    punctuation = String.fromCharCode(c - 65248);
  }
  if (c >= 33 && c <= 126 && type === 'toFull') {
    punctuation = String.fromCharCode(c + 65248);
  }
  return punctuation;
};

/**
 * 根据语言切换标点符号和空格
 * @param {String} lang
 * @param {String} punctuation
 */
var i18nPunctuation = function i18nPunctuation(lang, punctuation) {
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  // lang兼容处理
  lang = compatibleLang(lang);

  // 使用全角符号的语言
  var LANGUAGE_NOT_HAVE_LETTER = ['zh-cn', 'zh-tw', 'ja'];
  var type = LANGUAGE_NOT_HAVE_LETTER.includes(lang) ? 'toFull' : 'toHalf';
  // 半角符号语言需要空格字符分隔
  if (punctuation === ' ' || punctuation === '') {
    return type === 'toFull' ? '' : ' ';
  }
  // 中文顿号表示序号分隔时转为.
  if (punctuation === '、') {
    return type === 'toFull' ? '、' : '. ';
  }
  // 句号转换
  if (punctuation === '。' || punctuation === '.') {
    return type === 'toFull' ? '。' : '. ';
  }
  // 日语中用「」表示双引号
  if (lang === 'ja') {
    if (punctuation === '“') {
      return '「';
    } else if (punctuation === '”') {
      return '」';
    }
  }

  // 使用半角符号的在标点后添加空格
  return type === 'toFull' ? toggleHalfFullWidth(punctuation, type) : toggleHalfFullWidth(punctuation, type) + " ";
};

/**
 * 设置html的lang属性
 * @param {String} lang
 */
var i18nSetLang = function i18nSetLang(lang) {
  var _document;
  // lang兼容处理
  lang = compatibleLang(lang);
  if ((_document = document) !== null && _document !== void 0 && _document.documentElement) {
    document.documentElement.lang = lang || 'zh-cn';
  }
};

/**
 * 设置html的dir属性
 * @param {String} lang
 */
var i18nSetRtl = function i18nSetRtl(lang) {
  var _document2;
  // lang兼容处理
  lang = compatibleLang(lang);
  if (lang === 'ar' && (_document2 = document) !== null && _document2 !== void 0 && _document2.documentElement) {
    document.documentElement.dir = 'rtl';
  }
};
var i18nString = {
  i18nPunctuation: i18nPunctuation,
  i18nIsLongLang: i18nIsLongLang,
  i18nIsZh: i18nIsZh,
  i18nSetLang: i18nSetLang,
  i18nSetRtl: i18nSetRtl
};
export default i18nString;